import { Heading } from '@madpaws/design-system';
import React from 'react';

import styles from './HowItWorks.module.css';
import { HOW_IT_WORKS } from '../constants';

import type { ReactElement } from 'react';

export const HowItWorks = (): ReactElement => (
  <div className={styles.root}>
    <Heading alignment="centerAlign" fontFamily="heading" size="medium">
      How it works
    </Heading>
    <div className={styles.list}>
      {HOW_IT_WORKS.map((item, index) => (
        <div className={styles.item} key={index}>
          <Heading
            alignment="centerAlign"
            color="brandColor"
            fontFamily="heading"
            level={3}
            size="medium"
          >
            {index + 1}.
          </Heading>
          <div>
            <Heading level={3} size="small3x">
              {item.title}
            </Heading>
            <p>{item.description}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
);
